export function unusedPortalMember(member) {
  const rel = member.relationship || "";
  return (typeof rel === "string" && ["", "child"].includes(rel.trim().toLowerCase())) &&
    Object.entries(member).every(([field, value]) => ["relationship", "_new"].includes(field) ||
      value === null || value === undefined || (typeof value === "string" && !value.trim()));
}

export function portalMembersPayload(members) {
  return members.filter(member => !unusedPortalMember(member)).map(({ _new, ...member }) => member);
}

export function unresolvedMemberLinks(members, currentMembers) {
  const ids = new Set((currentMembers || []).map(m => m.id));
  return (members || []).flatMap((m, index, all) =>
    m.id && (!ids.has(m.id) || all.filter(row => row.id === m.id).length > 1) ? [index] : []);
}

export function currentMemberLabel(member) {
  const age = member.birth_year ? new Date().getFullYear() - member.birth_year : null;
  return [[member.first_name, member.last_name].filter(Boolean).join(" ") || "Name not available",
    age === null ? null : `age ~${age}`, member.gender, member.relationship].filter(Boolean).join(" · ");
}
